<dx-data-grid
  #dataGrid
  [dataSource]="comptageLignes"
  [showBorders]="true"
  [columnAutoWidth]="true"
  [allowColumnResizing]="true"
  [hoverStateEnabled]="true"
  [allowColumnReordering]="true"
  width="100%"
  height="100%"
  (onExporting)="onExporting($event)"
  >

  <dxo-paging [pageSize]="10"></dxo-paging>
  <dxo-pager
    [showPageSizeSelector]="true"
    [allowedPageSizes]="[10, 25, 50, 100]"
    [showInfo]="true"
    [visible]="true">
  </dxo-pager>

  <!-- #region Toolbar -->
  <dxo-toolbar>
    <dxi-item location="before">
      <div *dxTemplate>
        <app-gerer-grid-state [dataGrid]="dataGrid" [gridStorageKey]="storageKey"></app-gerer-grid-state>
      </div>
    </dxi-item>
    <dxi-item>
      <div *dxTemplate>
        <dx-button icon="refresh" hint="Rafraîchir" (onClick)="setDataSource()" stylingMode="text"></dx-button>
      </div>
    </dxi-item>
    <dxi-item name="groupPanel"></dxi-item>
    <dxi-item name="exportButton"></dxi-item>
    <dxi-item name="columnChooserButton"></dxi-item>
  </dxo-toolbar>
  <!-- #endregion -->

  <!-- #region Options  -->
  <dxo-filter-row [visible]="true"></dxo-filter-row>
  <dxo-header-filter [visible]="true"></dxo-header-filter>
  <dxo-group-panel [visible]="true"></dxo-group-panel>
  <dxo-grouping [autoExpandAll]="true"></dxo-grouping>
  <dxo-search-panel [visible]="true" [width]="240"></dxo-search-panel>
  <dxo-state-storing [storageKey]="storageKey" [enabled]="true" appStorage></dxo-state-storing>
  <dxo-column-chooser [enabled]="true" mode="select" [height]="600"></dxo-column-chooser>
  <dxo-export [enabled]="true"></dxo-export>
  <!-- #endregion -->

  <!-- #region Colonnes -->
  <dxi-column dataField="articleCodeBo" caption="Code article" [allowGrouping]="true"/>
  <dxi-column dataField="articleIntitule" caption="Libellé article" [allowGrouping]="true"/>
  <dxi-column dataField="quantite" caption="Quantité" [allowGrouping]="true"/>
  <dxi-column dataField="dlc" caption="DLC" dataType="date" [allowGrouping]="true"/>
  <dxi-column dataField="dluo" caption="DLUO" dataType="date" [allowGrouping]="true"/>
  <dxi-column dataField="numeroSerie" caption="Numéro de série" [allowGrouping]="true"/>
  <dxi-column dataField="numeroLot" caption="Numéro de lot" [allowGrouping]="true"/>
  <dxi-column dataField="referenceFournisseurPrincipal" caption="Référence fournisseur" [allowGrouping]="true" [visible]="false"/>
  <!-- #endregion -->
</dx-data-grid>